module.exports = __webpack_public_path__ + "static/drt5 - Copy-da26550009108af982f3d53ea7f8bd57.jpg";